import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Image {
  _publishUrl: string;
  _dynamicUrl?: string;
}

export interface SupportContent {
  html: string;
}

export interface ImageAndContentItem {
  title1: string;
  title2: string;
  title3: string;
  description: string;
  image1: string;
  image2: string;
  image3?: string | null;
  ctaText: string;
  ctaLink: string;
  bulletedContent: string[];
  sceneText: string;
  cardNumberPlaceholder: string;
  remindMeLaterCta: string;
  remindMeLaterCtaLink: string;
  addCardCta: string;
  addCardCtaLink: string;
  supportAndContactUsContent: SupportContent[];
}

interface SceneContentState {
  items: ImageAndContentItem[];
}

const initialState: SceneContentState = {
  items: [],
};

const sceneContentSlice = createSlice({
  name: "sceneContent",
  initialState,
  reducers: {
    // Action to update scene content
    setSceneContent: (state, action: PayloadAction<ImageAndContentItem[]>) => {
      state.items = action.payload;
    },
    // Optional: Action to reset scene content
    resetSceneContent: (state) => {
      state.items = [];
    },
  },
});

// Export actions and reducer
export const { setSceneContent, resetSceneContent } = sceneContentSlice.actions;
export default sceneContentSlice.reducer;
